import * as THREE from "three";


export default class ImagePlane {
	constructor(mesh, img) {
		this.refImage = img;
		this.mesh = mesh;
	}

	setParams() {
		// 参照するimg要素から大きさ、位置を取得してセット
		const rect = this.refImage.getBoundingClientRect();
		
		this.mesh.scale.x = rect.width;
		this.mesh.scale.y = rect.height;

		const x = rect.left - window.innerWidth / 2 + rect.width / 2;
		const y = -rect.top + window.innerHeight / 2 - rect.height / 2;
		this.mesh.position.set(x, y, this.mesh.position.z);

	}

	update(offset) {
		this.setParams();
		this.mesh.material.uniforms.uTime.value = offset;
	}
}